module.exports = __webpack_public_path__ + "static/media/price-img2.a63c16be.webp";